// import React from "react";
// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Button,
// } from "@mui/material";

// const ImageFormDialog = ({ open, onClose, onSubmit, imageData, isEditMode }) => {
//   const [formData, setFormData] = React.useState(imageData || {});

//   const handleChange = (field, value) => {
//     setFormData({ ...formData, [field]: value });
//   };

//   const handleSave = () => {
//     onSubmit(formData);
//   };

//   React.useEffect(() => {
//     setFormData(imageData || {});
//   }, [imageData]);

//   return (
//     <Dialog open={open} onClose={onClose}>
//       <DialogTitle>{isEditMode ? "Edit Image Details" : "Add New Image"}</DialogTitle>
//       <DialogContent>
//         <TextField
//           fullWidth
//           label="Title"
//           value={formData.title || ""}
//           onChange={(e) => handleChange("title", e.target.value)}
//           variant="outlined"
//           margin="normal"
//         />
//         <TextField
//           fullWidth
//           label="Text"
//           value={formData.text || ""}
//           onChange={(e) => handleChange("text", e.target.value)}
//           variant="outlined"
//           margin="normal"
//         />
//         <TextField
//           fullWidth
//           label="Action"
//           value={formData.action || ""}
//           onChange={(e) => handleChange("action", e.target.value)}
//           variant="outlined"
//           margin="normal"
//         />
//         <TextField
//           fullWidth
//           label="Action Type"
//           value={formData.actionType || ""}
//           onChange={(e) => handleChange("actionType", e.target.value)}
//           variant="outlined"
//           margin="normal"
//         />
//         <TextField
//           fullWidth
//           label="Valid From"
//           type="datetime-local"
//           value={formData.validFrom ? formData.validFrom.substring(0, 16) : ""}
//           onChange={(e) => handleChange("validFrom", e.target.value)}
//           variant="outlined"
//           margin="normal"
//           InputLabelProps={{
//             shrink: true,
//           }}
//         />
//         <TextField
//           fullWidth
//           label="Valid To"
//           type="datetime-local"
//           value={formData.validTo ? formData.validTo.substring(0, 16) : ""}
//           onChange={(e) => handleChange("validTo", e.target.value)}
//           variant="outlined"
//           margin="normal"
//           InputLabelProps={{
//             shrink: true,
//           }}
//         />
//         <TextField
//           fullWidth
//           label="Image URL"
//           value={formData.image_url || ""}
//           onChange={(e) => handleChange("image_url", e.target.value)}
//           variant="outlined"
//           margin="normal"
//         />
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="primary">
//           Cancel
//         </Button>
//         <Button onClick={handleSave} color="secondary">
//           {isEditMode ? "Save Changes" : "Add Image"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default ImageFormDialog;

import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  FormHelperText,
} from "@mui/material";

const ImageFormDialog = ({ open, onClose, onSubmit, imageData, isEditMode }) => {
  const [formData, setFormData] = React.useState(imageData || {});
  const [errors, setErrors] = React.useState({});

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleSave = () => {
    // Validate form data
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.image_url) newErrors.image_url = "Image URL is required";
    if (!formData.validFrom) newErrors.validFrom = "Valid From date is required";
    if (!formData.validTo) newErrors.validTo = "Valid To date is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Set error state
      return; // Stop saving if there are validation errors
    }

    // No errors, submit form
    onSubmit(formData);
  };

  React.useEffect(() => {
    setFormData(imageData || {});
    setErrors({}); // Reset errors when imageData changes
  }, [imageData]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{isEditMode ? "Edit Image Details" : "Add New Image"}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          label="Title"
          value={formData.title || ""}
          onChange={(e) => handleChange("title", e.target.value)}
          variant="outlined"
          margin="normal"
          error={!!errors.title}
          helperText={errors.title}
        />
        <TextField
          fullWidth
          label="Text"
          value={formData.text || ""}
          onChange={(e) => handleChange("text", e.target.value)}
          variant="outlined"
          margin="normal"
        />
        <TextField
          fullWidth
          label="Action"
          value={formData.action || ""}
          onChange={(e) => handleChange("action", e.target.value)}
          variant="outlined"
          margin="normal"
        />
        <TextField
          fullWidth
          label="Action Type"
          value={formData.actionType || ""}
          onChange={(e) => handleChange("actionType", e.target.value)}
          variant="outlined"
          margin="normal"
        />
        <TextField
          fullWidth
          label="Valid From"
          type="datetime-local"
          value={formData.validFrom ? formData.validFrom.substring(0, 16) : ""}
          onChange={(e) => handleChange("validFrom", e.target.value)}
          variant="outlined"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          error={!!errors.validFrom}
          helperText={errors.validFrom}
        />
        <TextField
          fullWidth
          label="Valid To"
          type="datetime-local"
          value={formData.validTo ? formData.validTo.substring(0, 16) : ""}
          onChange={(e) => handleChange("validTo", e.target.value)}
          variant="outlined"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          error={!!errors.validTo}
          helperText={errors.validTo}
        />
        <TextField
          fullWidth
          label="Image URL"
          value={formData.image_url || ""}
          onChange={(e) => handleChange("image_url", e.target.value)}
          variant="outlined"
          margin="normal"
          error={!!errors.image_url}
          helperText={errors.image_url}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSave} color="secondary">
          {isEditMode ? "Save Changes" : "Add Image"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageFormDialog;

